import React from 'react';
import PropTypes from 'prop-types';
import defaultStyles from './ClickableLink.module.scss';

const ClickableLink = props => (
    <a
        className={ props.styles.link }
        href={ props.value }
    >
        {props.value}
    </a>
);

ClickableLink.defaultProps = {
    styles: defaultStyles,
    value: ''
};

ClickableLink.propTypes = {
    styles: PropTypes.objectOf(PropTypes.string),
    value: PropTypes.string
};

export default ClickableLink;
